import React, { useEffect, useState } from "react";
import { BiArrowToTop } from "react-icons/bi";

const Footer = () => {
  const [showTopButton, setShowTopButton] = useState(false);
  const scrollHandler = () => {
    window.scrollY > window.innerHeight / 4
      ? setShowTopButton(true)
      : setShowTopButton(false);
  };
  const goTopHandler = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <div className="bg-indigo-900 text-white p-8 text-center ">
      Designed by hyunki,bae, Photo by Pexels
      <button
        onClick={goTopHandler}
        className={[
          "fixed right-4 bottom-4 px-3 py-3 drop-shadow-xl text-white bg-indigo-900 rounded-full will-change-transform transition-all transform duration-300 ease-in-out",
          showTopButton ? "opacity-100 scale-100" : "opacity-0 scale-0",
        ].join(" ")}
      >
        <BiArrowToTop className="w-6 h-6" />
      </button>
    </div>
  );
};

export default Footer;
